export default __webpack_public_path__ + "static/media/hazel.56f12732.jpg";